import { createFileRoute, redirect, notFound } from "@tanstack/react-router";
import { menuQueries } from "@/domain/menu/menu.query";
import { chefQueries } from "@/domain/chef/chef.query";
import { createChefSlug } from "@/lib/utils";

/**
 * Legacy redirect — l'ancienne page détail menu (`/menus/<slug>`) n'existe plus.
 * On redirige vers la fiche chef publique avec le menuId en query param,
 * ce qui ouvre automatiquement le popup détail du menu.
 */
export const Route = createFileRoute("/(public)/menus/$menuId")({
  beforeLoad: async ({ context: { queryClient }, params }) => {
    const parts = params.menuId.split("-");
    const id = parts[parts.length - 1];
    const numericId = Number(id);
    if (isNaN(numericId) || numericId <= 0) {
      throw notFound();
    }

    const menu = await queryClient
      .ensureQueryData(menuQueries.detail(numericId))
      .catch(() => null);
    if (!menu) throw notFound();

    const chef = await queryClient
      .ensureQueryData(chefQueries.profile(menu.chefId))
      .catch(() => null);

    const chefSlug = chef?.firstName
      ? createChefSlug(chef.firstName, menu.chefId)
      : String(menu.chefId);

    throw redirect({
      to: "/chefs/$chefId",
      params: { chefId: chefSlug },
      search: { menuId: numericId },
      replace: true,
    });
  },
});
